import { create } from "zustand";

type State = {
    selected_partner: string | null;
    selected_kassa: string | null;
    kassas_list: Kassa[] | null;
};

type Actions = {
    setselected_partner: (v: string | null) => void;
    setselected_kassa: (v: string | null) => void;
    setkassas_list: (v: Kassa[] | null) => void;
    reset: () => void;
};

const buildInitialState = (): State => ({
    selected_partner: null,
    selected_kassa: null,
    kassas_list: null,
});

const useKassaSettingsStore = create<State & Actions>((set) => ({
    ...buildInitialState(),

    setselected_partner: (v) => set({ selected_partner: v }),
    setselected_kassa: (v) => set({ selected_kassa: v }),
    setkassas_list: (v) => set({ kassas_list: v }),

    reset: () => set(buildInitialState()),
}));

export default useKassaSettingsStore;
